import React from 'react';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { ITextFieldProps, TextField } from '../../../../ui';
import { useFormContext } from 'react-hook-form';

export const LastName = (props: Partial<ITextFieldProps>) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = useFormContext();

	return (
		<TextField
			type="text"
			label={t('user_form_last_name_label')}
			placeholder={t('user_form_last_name_placeholder')}
			invalid={!!errors.lastName}
			error={errors.lastName?.message as string}
			autoComplete="family-name"
			{...props}
			{...register('lastName')}
		/>
	);
};
